import React, { useEffect } from "react";
import WebDevBanner from "../component/WebDevBanner";
import $ from "jquery"; // Import jQuery
import WebDevFlow from "../component/WebDevFlow";
import CustomNeed from "../component/CustomNeed";

const WebDev = () => {
  useEffect(() => {
    const win = window;

    function isElementVisible($el) {
      const viewTop = win.scrollY;
      const viewBottom = viewTop + window.innerHeight;
      const elTop = $el.offset().top;
      const elBottom = elTop + $el.height();
      return elBottom <= viewBottom && elTop >= viewTop;
    }

    function addAnimation($el, delay) {
      setTimeout(() => {
        $el.addClass("come-in");
        $el.attr("class", "webflow_circle come-in");
      }, delay);
    }

    const allMods1 = Array.from(document.querySelectorAll(".webflow_circle"));
    const allMods2 = Array.from(document.querySelectorAll(".html_circle"));
    const allMods3 = Array.from(document.querySelectorAll(".css_circle"));
    const allMods4 = Array.from(document.querySelectorAll(".js_circle"));

    win.addEventListener("scroll", () => {
      allMods1.forEach((el, i) => {
        const $el = $(el);
        if (isElementVisible($el)) {
          addAnimation($el, i * 200);
        }
      });

      allMods2.forEach((el, i) => {
        const $el = $(el);
        if (isElementVisible($el)) {
          addAnimation($el, i * 200);
        }
      });

      allMods3.forEach((el, i) => {
        const $el = $(el);
        if (isElementVisible($el)) {
          addAnimation($el, i * 200);
        }
      });

      allMods4.forEach((el, i) => {
        const $el = $(el);
        if (isElementVisible($el)) {
          addAnimation($el, i * 200);
        }
      });
    });

    const handleScroll = () => {
      const offset = window.pageYOffset;
      const wheight = window.innerHeight;
      const html = document.documentElement;
      const docheight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
      );
      let progress = (offset / (docheight - wheight)) * 3000;

      // Give the line a CSS gradient based on scroll position
      progress = 3000 - progress * 1.6;

      // Update the SVG element with the new stroke-dashoffset
      const fillingPath = document.getElementById("filling_path");
      if (fillingPath) {
        fillingPath.setAttribute("stroke-dashoffset", progress);
      }
    };

    // Add scroll event listener when the component mounts
    window.addEventListener("scroll", handleScroll);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <WebDevBanner />
      <WebDevFlow />
      {/* <CustomNeed /> */}
      <div className="why_us">
        <div className="wrapper">
          <h2>Why Choose Us?</h2>
          <div className="col_row">
            <div
              className="col_item"
              style={{
                backgroundImage: `url(./assets/images/portfolio/usbg1.svg)`,
              }}
            >
              <div className="icon">
                <img src="./assets/images/portfolio/us16.svg" alt="" />
              </div>
              <hr />
              <h3>Proactive Approach</h3>
              <p>Fixing issues before they impact users.</p>
            </div>
            <div
              className="col_item"
              style={{
                backgroundImage: `url(./assets/images/portfolio/usbg2.svg)`,
              }}
            >
              <div className="icon">
                <img src="./assets/images/portfolio/us17.svg" alt="" />
              </div>
              <hr />
              <h3><span>24/7</span> Support</h3>
              <p>Always available to address your concerns.</p>
            </div>
            <div
              className="col_item"
              style={{
                backgroundImage: `url(./assets/images/portfolio/usbg3.svg)`,
              }}
            >
              <div className="icon">
                <img src="./assets/images/portfolio/us18.svg" alt="" />
              </div>
              <hr />
              <h3>Customized Plans</h3>
              <p>Tailored maintenance packages for your needs.</p>
            </div>   
          </div>
        </div>
      </div>
      
    </>
  );
};

export default WebDev;
